import { LIGHT_COLORS, DARK_COLORS, RANDOM_COLORS, ROOM_COLORS } from './colors'

export const size = {
  mobileM: '375px',
  mobileL: '414px',
  mobileHorizontal: '667px',
  tablet: '768px',
  laptop: '1024px',
  laptopS: '1280px',
  laptopM: '1366px',
  laptopL: '1440px',
  laptopXL: '1600px',
  desktop: '1920px'
}

export const DEVICE = {
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  mobileHorizontal: `(min-width: ${size.mobileHorizontal})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopS: `(min-width: ${size.laptopS})`,
  laptopM: `(min-width: ${size.laptopM})`,
  laptopL: `(min-width: ${size.laptopL})`,
  laptopXL: `(min-width: ${size.laptopXL})`,
  desktop: `(min-width: ${size.desktop})`
}

export const DARK_SHADOWS = {
  xs: '0 1px 1px rgba(0,0,0,.3)',
  s: '0px 1px 4px rgba(0,0,0,.12)',
  m: '0px 4px 8px rgba(0,0,0,.12)',
  l: '0px 8px 12px rgba(0,0,0,.08)',
  xl: '0px 15px 40px rgba(0,0,0,.12)'
}

export const LIGHT_SHADOWS = {
  xs: '0px 1px 1px rgba(0,0,0,.1)',
  s: '0px 1px 4px rgba(0,0,0,.02)',
  m: '0px 4px 8px rgba(0,0,0,.04)',
  l: '0px 8px 12px rgba(0,0,0,.08)',
  xl: '0px 15px 40px rgba(0,0,0,.12)'
}

export const DARK_INSET_SHADOWS = {
  xl: 'inset 0 0 40px 0 rgba(0,0,0,.1)'
}

export const LIGHT_INSET_SHADOWS = {
  xl: 'inset 0 0 40px 0 rgba(0,0,0,.1)'
}

export const DURATION = {
  s: '.175s',
  m: '.35s',
  l: '.75s',
  xl: '1s'
}

export const FUNCTION = {
  oq: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  ei: 'cubic-bezier(0.42,0,1,1)',
  l: 'cubic-bezier(0, 0, 1, 1)',
  e: 'cubic-bezier(0.25, 0.1, 0.25, 1)'
}

export const LIGHT_THEME = {
  shadow: LIGHT_SHADOWS,
  insetShadow: LIGHT_INSET_SHADOWS,
  name: 'light',
  color: LIGHT_COLORS,
  randomColors: RANDOM_COLORS.map(([, dayColor]) => dayColor),
  roomColors: ROOM_COLORS.map(([, dayColor]) => dayColor),
  duration: DURATION,
  function: FUNCTION,
  device: DEVICE
}

export const DARK_THEME = {
  shadow: DARK_SHADOWS,
  insetShadow: DARK_INSET_SHADOWS,
  name: 'dark',
  color: DARK_COLORS,
  randomColors: RANDOM_COLORS.map(([nightColor]) => nightColor),
  roomColors: ROOM_COLORS.map(([nightColor]) => nightColor),
  duration: DURATION,
  function: FUNCTION,
  device: DEVICE
}

export const THEMES = [DARK_THEME, LIGHT_THEME]
